module.exports = __webpack_public_path__ + "img/logowithName 1.5 website.2059e02f.png";